import axios from 'axios'

const instance = axios.create({
  baseURL: '/cloudmoney',
  timeout: 5000
})

instance.interceptors.request.use(
  config => {
    let token = sessionStorage.getItem('token')
    if (token) {
      config.headers = {
        'token': token
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
instance.interceptors.response.use(
  res => {
    return res.data
  },
  error => {
    return Promise.reject(error)
  }
)

export default instance
